<template>
  <section class="hide-label">
    <template
      v-if="
        question.input_type.name == 'text' &&
          question.input_layout.name == 'input text'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <span class="color-black">{{ question.answer }}</span>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'text' &&
          question.input_layout.name == 'date'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <span class="color-black">{{ question.answer }}</span>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'text' &&
          question.input_layout.name == 'email'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <span class="color-black">{{ question.answer }}</span>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'text' &&
          question.input_layout.name == 'url'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <a target="_blank" :href="question.answer || ''" class="color-black">{{
          question.answer || ""
        }}</a>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'text' &&
          question.input_layout.name == 'text area'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <span class="color-black">{{ question.answer }}</span>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'select_one' &&
          question.input_layout.name == 'dropdown'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <span class="color-black">{{
          question ? question.answer.value : ""
        }}</span>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'select_one' &&
          question.input_layout.name == 'progress'
      "
    >
      <v-card class="pa-4 mb-4 transparent-field radius-14">
        <span class="mb-p-2" v-html="question.body"></span>
        <v-slider
          class="mt-8"
          v-model="choiceValue"
          :tick-labels="
            question.choices.map(el => {
              return el.value;
            })
          "
          track-color="#eeeeee"
          :min="1"
          :max="question.choices.length"
          step="1"
          ticks
          color="success"
          height="2"
          readonly
          thumb-label="always"
          tick-size="4"
          :thumb-size="20"
        ></v-slider>
      </v-card>
    </template>
    <template
      v-if="
        question.input_type.name == 'select_one' &&
          question.input_layout.name == 'radio'
      "
    >
      <section class="my-2 radio-choice">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <!-- <v-alert class="mt-2 py-4 alert-bg" dense outlined color="success">
          <span>{{ question.answer.value || "" }}</span>
        </v-alert> -->
        <v-chip
          outlined
          class="radius-12 mt-1 pa-5 alert-bg"
          color="success"
          large
        >
          <strong>{{ question ? question.answer.value : "" }}</strong>
        </v-chip>
      </section>
    </template>
    <template
      v-if="
        (question.input_type.name == 'multiple_select' &&
          question.input_layout.name == 'dropdown') ||
          (question.input_type.name == 'multiple_select' &&
            question.input_layout.name == 'checkbox')
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <span
          class="color-black"
          v-for="(answer, index) in question.answer"
          :key="index"
          >{{ index + 1 }}{{ " - " + answer ? answer.value : "" }}<br
        /></span>
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'file' &&
          question.input_layout.name == 'video'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <a
          target="_blank"
          :href="question.answer.path || ''"
          class="color-black"
          >{{ question.answer.path || "" }}</a
        >
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'boolean' &&
          question.input_layout.name == 'button'
      "
    >
      <section class="my-2">
        <small>
          <span class="mb-p-2 color-gray" v-html="question.body"></span>
        </small>
        <v-chip
          class="radius-12 mt-1 px-5"
          v-if="question.answer == 0"
          color="error"
          large
        >
          <strong>No</strong>
        </v-chip>
        <v-chip class="radius-12 mt-1 px-5" v-else color="success" large>
          <strong>Yes</strong>
        </v-chip>
      </section>
    </template>
    <template
      v-else-if="
        question.input_type.name == 'file' &&
          question.input_layout.name == 'photo'
      "
    >
      <section class="mb-2 file-upload">
        <span class="mb-p-2" v-html="question.body"></span>
        <v-avatar size="50" style="cursor: pointer" title="Magnify">
          <v-img
            @click="showImagePreview"
            :src="question.answer ? question.answer.path : ''"
          ></v-img>
        </v-avatar>
        <global-image-preview
          :showDialog="overlay"
          :imagePath="question.answer ? question.answer.path : ''"
          @closePreview="overlay = false"
        />
      </section>
    </template>
    <template
      v-if="
        question.input_type.name == 'file' &&
          question.input_layout.name == 'file'
      "
    >
      <span class="mb-p-2" v-html="question.body"></span>
      <a target="_blank" :href="question.answer ? question.answer.path : ''">
        <v-avatar
          class="mt-3"
          size="50"
          style="cursor: pointer"
          title="Magnify"
        >
          <v-img :src="require('@/assets/imgs/pdf-icon.png')"></v-img>
        </v-avatar>
      </a>
    </template>
    <template
      v-else-if="
        (question.input_type.name == 'multiple_select' &&
          question.input_layout.name == 'draggable list') ||
          (question.input_type.name == 'multiple_select' &&
            question.input_layout.name == 'draggable ordered list')
      "
    >
      <section v-if="question.answer.length > 0">
        <span class="mb-p-2" v-html="question.body"></span>
        <section class="drag-style mt-4">
          <v-card
            class="pa-2 mb-2 radius-14"
            v-for="element in question.answer"
            :key="element.id"
          >
            <v-icon class="mr-2">mdi-grain</v-icon>
            {{ element ? element.value : "" }}
            <!-- <v-icon small @click="removeCard">mdi-delete</v-icon> -->
          </v-card>
        </section>
      </section>
    </template>
    <template
      v-else-if="
        question.input_type.name == 'collector' &&
          question.input_layout.name == 'dropdown' &&
          question.bag
      "
    >
      <h2 class="mb-3">{{ question.bag.name }}</h2>
      <section v-for="source in question.bag.sources" :key="source.index">
        <div v-if="source.is_default_to_show">
          <h4 class="mb-4">{{ source.display_name }}</h4>
          <section
            v-for="sourceQuestion in source.questions"
            :key="sourceQuestion.index"
          >
            <Question :question="sourceQuestion" />
          </section>
        </div>
      </section>
    </template>
    <!-- Nested Question -->
    <Question
      v-if="
        question.answer &&
          question.answer.questions &&
          question.answer.questions[0]
      "
      :question="question.answer.questions[0]"
      :form="form"
    />
    <!-- Nested Question -->
  </section>
</template>

<script>
export default {
  components: {
    // uploadFilePdf: () => import("../../../components/uploadFilePdf"),
    Question: () => import("./Question")
    // test: () => import("./test")
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      choiceId: this.question.answer ? this.question.answer.id : null,
      choiceValue: this.question.answer ? this.question.answer.label : null,
      maxSize: 2.048,
      pdfSize: 2.048,
      dialog: false,
      date_modal: false,
      addSource: "",
      nonSelectedSources: [],
      overlay: false,
      form: {}
    };
  },
  watch: {
    question: {
      handler(newVal) {
        // handle bag questions
        if (newVal.parentsTree) {
          this.setBagQuesValue(newVal);
        } else if (!newVal.bag) {
          const quesValue = this.getQuesValue(newVal.answer);
          if (quesValue || quesValue === 0) {
            this.form[newVal.id] = quesValue;
          }
        }
      },
      // immediate: true, Images Bug
      deep: true
    },
    choiceId: {
      handler(newId) {
        if (this.question.answer && this.question.answer.questions) {
          this.removeNestedAnswers(this.question.answer.questions);
        }
        this.question.answer = this.question.choices.filter(
          choice => choice.id.toString() === newId.toString()
        )[0];
        if (this.question.answer.questions) {
          this.addNestedAnswers(this.question.answer.questions);
        }
        if (this.question.bag != null) {
          this.question.bag.sources.forEach(source => {
            if (source.questions) {
              this.addNestedAnswers(source.questions);
            }
          });
        }
      }
    },
    choiceValue: {
      handler(newVal) {
        this.question.answer = this.question.choices.filter(
          choice => choice.label.toString() === newVal.toString()
        )[0];
      }
    }
  },
  methods: {
    getQuesValue(answer) {
      if (answer && typeof answer === "object" && answer !== null) {
        return answer.id ? answer.id : answer;
      } else if (answer || answer === 0) {
        return answer;
      }
      return null;
    },
    setBagQuesValue(question) {
      const treeLen = question.parentsTree.length;
      let currentTreeNode = null;
      // first case for single node bag questions
      // second two cases to handle multi node nested bag questions
      question.parentsTree.forEach((node, index) => {
        if (treeLen === 1) {
          this.form[node.grandQuesId].bagData.sourcesObj[node.sourceId][
            node.quesId
          ] = this.getQuesValue(question.answer);
        } else if (index === treeLen - 1) {
          currentTreeNode[node.grandQuesId].bagData.sourcesObj[node.sourceId][
            node.quesId
          ] = this.getQuesValue(question.answer);
        } else {
          currentTreeNode = this.form[node.grandQuesId].bagData.sourcesObj[
            node.sourceId
          ][node.quesId];
        }
      });
    },
    addNestedAnswers(questions) {
      questions.forEach(ques => {
        if (
          ques.answer &&
          typeof ques.answer === "object" &&
          ques.answer !== null
        ) {
          if (ques.bag != null) {
            ques.bag.sources.forEach(source => {
              if (source.questions) {
                this.addNestedAnswers(source.questions);
              }
            });
          }
          this.form[ques.id] = ques.answer.id;
          if (ques.answer.questions) {
            this.addNestedAnswers(ques.answer.questions);
          }
        } else if (ques.answer || ques.answer === 0) {
          this.form[ques.id] = ques.answer;
        }
      });
    },
    removeNestedAnswers(questions) {
      questions.forEach(ques => {
        if (
          ques.answer &&
          typeof ques.answer === "object" &&
          ques.answer !== null
        ) {
          delete this.form[ques.id];
          if (ques.answer.questions) {
            this.removeNestedAnswers(ques.answer.questions);
          }
        } else if (ques.answer || ques.answer === 0) {
          delete this.form[ques.id];
        }
      });
    },
    sourcesSelected() {
      this.dialog = true;
      this.nonSelectedSources = this.question.bag.sources.filter(
        item => !item.is_default_to_show
      );
    },
    done() {
      console.log(this.addSource);
      this.addSource.map(el => {
        return (el.is_default_to_show = 1);
      });
      this.dialog = false;
    },
    showImagePreview() {
      if (this.question.answer.path) {
        this.overlay = true;
      }
    }
  }
};
</script>
<style lang="scss">
.drag-style {
  border-radius: 14px;
  border: 1px solid #d9cfcf;
  padding: 1rem;
  min-height: calc(100% - 48px);
  background-color: #d5ecfa;
}
</style>
